import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor() { }
  private tabName:string;
  private trayName:string;

    public setGlobalTabName(currentTabName:string) {
      this.tabName = currentTabName;
    }
    public getGlobalTabName():string{
      return this.tabName;
    }
    public setGlobalTrayName(currentTrayName:string) {
      this.trayName = currentTrayName;
    }
    public getGlobalTrayName():string{
      return this.trayName;
    }

}
